class ReferralHistory {
	constructor(referrals, labelIfCompleted, labelIfNotCompleted) {
		this.referrals = referrals;
		this.labelIfCompleted = labelIfCompleted;
		this.labelIfNotCompleted = labelIfNotCompleted;
	}

	buildReferralHistoryTable() {
			$(".referral-history-data").append(
				$("<h3>", {
					text: "YOUR REFERRALS"
				}),
				$("<table>").addClass("referral-history-table").append(
					$("<thead>").append(
						$("<tr>").append(
							$("<th>").text("EMAIL"),
							$("<th>").text("STATUS")
						)
					),
					$("<tbody>").addClass("referral-history-data-table-body")
				)
			)
	}

	getReferralStatusLabel(referral) {
		return referral.completedAt === null ? this.labelIfNotCompleted : this.labelIfCompleted
	}

	buildReferralHistoryData() {
		this.referrals.forEach(referral => {
				$(".referral-history-data-table-body").append(
					$("<tr>").append(
						$("<td>").text(referral.email),
						$("<td>").text(this.getReferralStatusLabel(referral))
					)
				)
		})
	}

}




